<template>
  <div class="main">
    <div class="header">
      <div class="logo">
        <img src="../../assets/images/FjcCn2rtFf-h6r2pt--N4DGfkY7a.png" alt="logo" style="width: 20%; margin: 0 10px;">{{ $t('common.website') }}
      </div>
      <div class="nav-body">
        <span v-for="(item, index) in navData" :key="index">
          <div :class="['nav ' + (index === currentIndex ? 'selectcd' : '')]"  @click="showComponents(index)" v-if="index !== 1">{{ item.title }}</div>
          <el-dropdown v-else>
            <div :class="['nav ' + (index === currentIndex ? 'selectcd' : '')]">{{ $t('common.nav2') }}<i class="el-icon-arrow-down el-icon--right"></i></div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="jumpAdv('planView')" v-text="$t('common.nav2_1')"></el-dropdown-item>
              <el-dropdown-item @click.native="jumpAdv('GroupView')" v-text="$t('common.nav2_2')"></el-dropdown-item>
              <el-dropdown-item @click.native="jumpAdv('AdvView')" v-text="$t('common.nav2_3')"></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </div>
      <!-- <div class="lang" style="height: 66px; line-height: 66px;">
        <el-radio-group v-model="languare" size="mini" fill="#f90">
          <el-radio-button label="中文"></el-radio-button>
          <el-radio-button label="英文"></el-radio-button>
        </el-radio-group>
      </div> -->
      <div class="right">
        <el-dropdown style="float: right; color: rgba(255,255,255,0.75); margin-right: 20px;">
          <span class="header-btn">
            <span style="color: #fff; margin-right: 10px;">{{ user_name }}</span><i class="el-icon-user-solid" aria-hidden="true" style="font-size: 20px; color: #fff;"></i><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="showComponents(4)"><i style="padding-right: 8px" class="fa fa-cog"></i>{{ $t('common.user_center') }}</el-dropdown-item>
            <el-dropdown-item @click.native="logout"><i style="padding-right: 8px" class="fa fa-key"></i>{{ $t('common.exit_system') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="app-body">
      <!-- <el-scrollbar style="height: 100%;"> -->
      <div id="mainContainer" class="main-container" v-loading="true" element-loading-text="loading..." element-loading-background="#F9F9F9">
        <div class="layout-right jm-animate">
          <component :is="current" @jump_plan="showComponents(1)"
          @jump_form_plan="jump_form_plan"
          @jump_adv="jump_adv"
          @jump_form_group="jump_form_group"
          @jump_form_adv="jump_form_adv"
          @plan_call_back="plan_call_back"
          @group_call_back="group_call_back"
          @jumpAdv="jumpAdv"
          :plan_id="plan_id"
          :group_id="group_id"
          :plan_data="plan_data"
          :group_data="group_data"
          :adv_data="adv_data"
          ></component>
        </div>
      </div>
      <!-- </el-scrollbar> -->
    </div>
  </div>
</template>

<script>

export default {
  /* global require */
  data() {
    return {
      adminInfo: [],
      current: 'HomeView',
      currentIndex: 0,
      user_name: '...',
      navData: [
        {
          title: this.$t('common.nav1'),
          components: 'HomeView',
          icon: 'fa fa-home'
        },
        {
          title: this.$t('common.nav2'),
          components: 'PlanView',
          icon: 'fa fa-bell-o'
        },
        {
          title: this.$t('common.nav3'),
          components: 'DataView',
          icon: 'fa fa-bar-chart'
        },
        {
          title: this.$t('common.nav4'),
          components: 'BillView',
          icon: 'fa fa-bar-chart'
        },
        // {
        //   title: '受众分析',
        //   components: 'AddressView',
        //   icon: 'el-icon-share'
        // },
        {
          title: this.$t('common.nav5'),
          components: 'UsersView',
          icon: 'fa fa-user-circle-o'
        }
      ],
      plan_id: '',
      group_id: '',
      plan_data: [],
      group_data: [],
      adv_data: [],
      languare: '中文'
    };
  },
  created() {
    const lang = localStorage.lang || 'cn';
    this.languare = lang === 'cn' ? '中文' : '英文';
    console.log(this.languare);
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$http.post('/trader/index/getUserInfo').then(res => {
        if (res.code === 200 && res.data.company_name !== undefined) {
          sessionStorage.setItem('user_info', JSON.stringify(res.data));
          this.user_name = res.data.company_name;
        } else {
          this.$message.error('not find the user!!!');
          this.logout();
        }
      });
    },
    showComponents(index) {
      if (this.current !== this.navData[index].components) {
        this.$function.showLoading();
        this.currentIndex = index;
        this.current = this.navData[index].components;
      }
    },
    jumpAdv(components) {
      this.currentIndex = 1;
      this.current = components;
    },
    logout() {
      sessionStorage.removeItem(this.$Config.tokenKey);
      this.$router.push({ path: '/login' });
    },
    jump_adv(current) {
      this.current = current;
    },
    jump_form_plan(plan_data = []) {
      this.currentIndex = -1;
      this.current = 'CreatePlan';
      this.plan_data = plan_data;
    },
    jump_form_group(group_data = []) {
      this.current = 'CreateGroup';
      this.group_data = group_data;
    },
    jump_form_adv(adv_data = []) {
      this.current = 'CreateAdv';
      this.adv_data = adv_data;
    },
    plan_call_back(plan_id) {
      this.plan_id = plan_id;
      this.current = 'CreateGroup';
    },
    group_call_back(group_id) {
      this.group_id = group_id;
      this.current = 'CreateAdv';
    }
  },
  mounted() {

  },
  watch: {
    'languare'(val) {
      this.$i18n.locale = val === '英文' ? 'en' : 'cn';
      localStorage.setItem('lang', val === '英文' ? 'en' : 'cn');
    }
  },
  components: {
    HomeView: resolve => require(['@/views/Index/Lists.vue'], resolve),
    // PlanView: resolve => require(['@/views/Plan/Lists.vue'], resolve),
    UsersView: resolve => require(['@/views/Users/Lists.vue'], resolve),
    BudgetView: resolve => require(['@/views/Budget/Lists.vue'], resolve),
    AddressView: resolve => require(['@/views/Address/Lists.vue'], resolve),
    DataView: resolve => require(['@/views/Data/Lists.vue'], resolve),
    BillView: resolve => require(['@/views/Bill/Lists.vue'], resolve),

    PlanView: resolve => require(['@/views/Plan/Components/Plan.vue'], resolve),
    GroupView: resolve => require(['@/views/Plan/Components/Group.vue'], resolve),
    AdvView: resolve => require(['@/views/Plan/Components/Adv.vue'], resolve),
    CreatePlan: resolve => require(['@/views/Plan/Components/create_plan.vue'], resolve),
    CreateGroup: resolve => require(['@/views/Plan/Components/create_group.vue'], resolve),
    CreateAdv: resolve => require(['@/views/Plan/Components/create_adv.vue'], resolve)
  }
};
</script>
<style lang="less">
@import '../../assets/css/style.less';
@header-bg: #00C6C6;

.el-menu-item .is-active {
  background-color: #00C6C6 !important;
}

.nav {
  height: 66px;
  line-height: 66px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  padding: 0 20px;
  position: relative;
}

.nav:hover {
  cursor: pointer;
  color: #ffffff;
}

.selectcd {
  color: #fff;
}

.selectcd::after {
  content: '';
  display: inline-block;
  width: 24px;
  height: 4px;
  background: #fff;
  border-radius: 2px;
  position: absolute;
  bottom: 13px;
  left: 50%;
  transform: translateX(-50%);
}

// .el-menu-item:focus,
// .el-menu-item:hover,
// .el-submenu__title:hover {
//   background-color: #FFF !important;
// }

.main {
  display: flex;
  .el-menu:not(.el-menu--collapse) {
    width: 230px;
  }
  .app-body {
    width: 100%;
    height: calc(100% - 66px);
    margin-top: 66px;
    background: #F9F9F9;
    -webkit-transition: margin-left 0.3s ease-in-out;
    transition: margin-left 0.3s ease-in-out;
  }
  .main-container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: relative;
    .layout-right {
      width: 100%;
      margin: 0 auto;
    }
  }
}

.header {
  width: 100%;
  position: fixed;
  display: flex;
  height: 66px;
  background-color: @header-bg;
  box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  z-index: 10;
  .logo {
    width: 220px;
    height: 66px;
    overflow: hidden;
    line-height: 50px;
    color: #CED3D9;
    background-color: @header-bg;
    -webkit-transition: width 0.35s;
    transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    color: #fff;
    font-weight: bold;
    font-size: 18px;
    .min {
      display: none;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .nav-body {
    width: calc(100% - 550px);
    display: flex;
    margin-left: 20px;
  }
  .right {
    position: absolute;
    right: 0;
    width: 230px;
  }
  .header-btn {
    overflow: hidden;
    height: 66px;
    display: inline-block;
    text-align: center;
    line-height: 66px;
    cursor: pointer;
    padding: 0 14px;
    .el-badge__content {
      top: 14px;
      right: 7px;
      text-align: center;
      font-size: 9px;
      padding: 0 3px;
      background-color: #00a65a;
      color: #fff;
      border: none;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: 0.25em;
    }
  }
  .header-btn:hover {
    background-color: @header-bg;
  }
}
.menu {
  border-right: none;
}
.el-menu--vertical {
  min-width: 190px;
}
</style>
